import 'core-js/stable'
import { getPermissions } from '@/config/permissions'
import { createApp } from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import settings from '../public/settings.json'
import store from './store'
import axios from 'axios'
import { showToast } from './toastBus'
import SearchableSelect from './components/SearchableSelect.vue'

const app = createApp(App)
app.component('SearchableSelect', SearchableSelect)

app.config.performance = true
app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue Error]', info, err)
}

const baseAPI = axios.create({
  baseURL: settings.apiURL
})

const UNAUTHORIZED = 401

app.mixin({
  data() {
    return {
      lastActivity: Date.now()
    }
  },
  computed: {
    currencyCode() {
      return (this.user && this.user.currencyCode) || (this.users && this.users.currencyCode) || 'RM'
    }
  },
  mounted() {
    document.addEventListener('mousemove', this.updateLastActivity)
    document.addEventListener('keypress', this.updateLastActivity)
    this.timer = setInterval(() => {
      const elapsedTime = Date.now() - this.lastActivity
      if (elapsedTime >= 24 * 60 * 60 * 1000) {
        clearInterval(this.timer)
      }
    }, 5000)
  },
  unmounted() {
    document.removeEventListener('mousemove', this.updateLastActivity)
    document.removeEventListener('keypress', this.updateLastActivity)
    clearInterval(this.timer)
  },
  methods: {
    GetBaseUrl() {
      return settings.apiURL
    },
    updateLastActivity() {
      this.lastActivity = Date.now()
    },
    UserAuth() {
      return this.$API
        .get(this.$UserAuth, { withCredentials: true })
        .then(response => {
          return response.status == 202
        })
    },
    GoToSignUp() {
      let path = this.$router.currentRoute.value.path
      if (path.toLowerCase() != '/index') {
        this.$router.push('/Index')
      }
    },
    GoToHome() {
      this.$router.push('/Dashboard')
    },
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            this.$router.push('/Login')
          }
        })
    },
    GoToDashboard() {
      this.$router.push('/Dashboard')
    },
    userRole() {
      return localStorage.getItem('adminRole') || 'admin'
    },
    canEdit() {
      const role = this.userRole()
      const routeName = this.$route?.name
      const perm = getPermissions()[routeName]
      if (perm) return perm.edit.includes(role)
      return role !== 'sales'
    },
    GoToLogin() {
      let path = this.$router.currentRoute.value.path
      if (path.toLowerCase() != '/login') {
        this.$router.push({
          path: '/Login',
          query: {
            targetUrl: this.$router.currentRoute.value.fullPath,
          }
        })
      }
    },
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, { withCredentials: true })
        .then(response => {
          if (response.status == 200) {
            this.users = response.data
          }
        })
    },
  }
})

baseAPI.interceptors.response.use(response => response, error => {
  const status = error.response?.status
  if (status === UNAUTHORIZED) {
    const current = router.currentRoute.value.path.toLowerCase()
    if (current !== '/login') {
      router.push('/Login')
    }
  } else if (status >= 500) {
    showToast('Server error. Please try again later.', 'error')
  } else if (!error.response) {
    showToast('Network error. Check your connection.', 'error')
  }
  return Promise.reject(error)
})

app.config.globalProperties.$toast = showToast

app.config.globalProperties.$API = baseAPI
app.config.globalProperties.$log = console.log.bind(console)

app.config.globalProperties.$GetUserToken = 'kiddo/GetTuitionOwner'

app.config.globalProperties.$EditSchedule = 'kiddo/Read/ScheduleDetails'
app.config.globalProperties.$DuplicateSchedule = 'kiddo/Read/ScheduleToDuplicate'
app.config.globalProperties.$GetListSubject = 'kiddo/Read/ScheduleSubjectList'
app.config.globalProperties.$GetListSubjectCopy = 'kiddo/Read/ScheduleSubjectListCopy'
app.config.globalProperties.$ProfileTeacher = 'kiddo/Read/TeacherProfile'
app.config.globalProperties.$ProfessionalTeacher = 'kiddo/Read/TeacherProfessional'
app.config.globalProperties.$ListSubject = 'kiddo/Read/SubjectList'
app.config.globalProperties.$ListGrade = 'kiddo/Read/GradeList'
app.config.globalProperties.$ListTeacher = 'kiddo/Read/FindTutorTeacherList'
app.config.globalProperties.$FilterTeacher = 'kiddo/Read/FilterTeacher'
app.config.globalProperties.$ListChild = 'kiddo/Read/ListChild'
app.config.globalProperties.$UserType = 'kiddo/Read/StatusUserType'
app.config.globalProperties.$DetailParent = 'kiddo/Read/DetailParent'
app.config.globalProperties.$AllWaitingList = 'kiddo/Read/GetWaitingList'
app.config.globalProperties.$Request = 'kiddo/Read/GetRequest'
app.config.globalProperties.$RequestNotificationStudent = 'kiddo/Read/RequestNotificationStudent'
app.config.globalProperties.$CheckStatusJob = 'kiddo/Read/CheckingStatusJob'
app.config.globalProperties.$CheckTutorJob = 'kiddo/Read/CheckingTutorJob'
app.config.globalProperties.$Faq = 'kiddo/Read/GetFaq'
app.config.globalProperties.$AnswerFaqById = 'kiddo/Read/GetFaqById'
app.config.globalProperties.$InsertFindTutors = 'kiddo/Insert/SearchTutor'
app.config.globalProperties.$SignOut = 'kiddo/Insert/SignOut'
app.config.globalProperties.$UserAuth = 'kiddo/Insert/IsAuthenticated'
app.config.globalProperties.$SignUp = 'kiddo/Insert/Register'
app.config.globalProperties.$Blog = 'kiddo/Read/ListBlog'
app.config.globalProperties.$BlogById = 'kiddo/Read/ListBlogById'
app.config.globalProperties.$News = 'kiddo/Read/GetArticleSome'

app.config.globalProperties.$AllStudentName = 'kiddo/Read/AllStudentName'
app.config.globalProperties.$FindtutorFullDetails = 'kiddo/Read/CheckFullFindTutor'
app.config.globalProperties.$NotificationTeacher = 'kiddo/Read/NotificationTeacher'
app.config.globalProperties.$NotificationStudent = 'kiddo/Read/NotificationStudent'
app.config.globalProperties.$Languages = 'kiddo/Read/GetLanguage'
app.config.globalProperties.$Sessions = 'kiddo/Read/GetSession'
app.config.globalProperties.$Times = 'kiddo/Read/GetTime'
app.config.globalProperties.$Durations = 'kiddo/Read/GetDuration'
app.config.globalProperties.$DurationGroups = 'kiddo/Read/GetDurationGroup'
app.config.globalProperties.$ConfirmationClass = 'kiddo/Read/ConfirmationClass'
app.config.globalProperties.$ConfirmationClassStatus = 'kiddo/Read/CheckConfirmation'
app.config.globalProperties.$CheckStatusByFindTutorID = 'kiddo/Read/CheckStatusByFindTutorID'
app.config.globalProperties.$NotificationClassLanguage = 'kiddo/Read/NotificationClassLanguage'
app.config.globalProperties.$NotificationClassSession = 'kiddo/Read/NotificationClassSession'
app.config.globalProperties.$NotificationStudentResponse = 'kiddo/Read/NotificationStudentResponse'
app.config.globalProperties.$NotificationClassTime = 'kiddo/Read/NotificationClassTime'
app.config.globalProperties.$GetAcceptJob = 'kiddo/Read/GetAcceptJob'
app.config.globalProperties.$NotifyStudentJobAccepted = 'kiddo/Read/NotifyStudentJobAccepted'
app.config.globalProperties.$NotifyStudentTutorResponse = 'kiddo/Read/NotifyStudentTutorResponse'
app.config.globalProperties.$NotifyTeacherSetSchedule = 'kiddo/Read/NotifyTeacherSetSchedule'
app.config.globalProperties.$NotificationConfirmResponseStudent = 'kiddo/Read/NotificationConfirmResponseStudent'
app.config.globalProperties.$NotificationConfirmResponseToTeacher = 'kiddo/Read/NotificationConfirmResponseToTeacher'
app.config.globalProperties.$TeacherClassGrade = 'kiddo/Read/TeacherClassGrade'
app.config.globalProperties.$GetFindTutor = 'kiddo/Read/FindTutor'
app.config.globalProperties.$ListRequest = 'kiddo/Read/GetListRequest'
app.config.globalProperties.$FindTutorStudent = 'kiddo/Read/FindTutorStudent'
app.config.globalProperties.$NotificationTeacherSchedule = 'kiddo/read/NotificationTeacherSchedule'
app.config.globalProperties.$AllFindTutor = 'kiddo/Read/GetFindTutorAllId'
app.config.globalProperties.$TeacherByFindTutor = 'kiddo/Read/GetTeacherByFindTutorId'
app.config.globalProperties.$OfferDirectFindTutor = 'kiddo/Insert/OfferDirectToTeacher'
app.config.globalProperties.$NotificationAll = 'kiddo/read/AllNotificationLimitAuthorizeByWeb'
app.config.globalProperties.$NotificationAllDetail = 'kiddo/read/AllNotificationLimitAuthorizeByWebDetail'
app.config.globalProperties.$GetSubjectPackage = 'kiddo/read/GetSubjectPackage'
app.config.globalProperties.$AllClassPackage = 'kiddo/Read/AllClassPackage'
app.config.globalProperties.$PackageById = 'kiddo/Read/PackageById'
app.config.globalProperties.$GetListParent = 'kiddo/Read/GetListParent'
app.config.globalProperties.$GetStudentTcByPaginate = 'kiddo/Read/GetStudentTcByPaginate'

//Quiz
app.config.globalProperties.$CheckStudentSubGraStat = 'kiddo/Read/CheckStudentSubGraStat'
app.config.globalProperties.$StudentUpdateStatus = 'kiddo/Insert/StudentUpdateStatus'
app.config.globalProperties.$QuizSubjectList = 'kiddo/Read/QuizSubjectAll'
app.config.globalProperties.$QuizTeacherDetails = 'kiddo/Read/TeacherQuizGroupBySubject'
app.config.globalProperties.$QuizTeacherStatistics = 'kiddo/Read/TeacherQuizCountStudentAnswer'
app.config.globalProperties.$QuizTeacherPublishByQuiz = 'kiddo/Read/QuizTeacherPublishByQuiz'
app.config.globalProperties.$QuizGradeList = 'kiddo/Read/QuizGradeAll'
app.config.globalProperties.$QuizSummary = 'kiddo/Read/QuizSummary'
app.config.globalProperties.$QuizPreview = 'kiddo/Read/QuizPreview'
app.config.globalProperties.$QuizStartNumber = 'kiddo/Read/QuizNo'
app.config.globalProperties.$CreateQuizTitle = 'kiddo/Insert/TeacherCreateQuiz'
app.config.globalProperties.$CreateQuizQuestion = 'kiddo/Insert/InsertTeacherQuestion'
app.config.globalProperties.$QuizTeacherNewQuestion = 'kiddo/Insert/QuizTeacherNewQuestion'
app.config.globalProperties.$EditQuizQuestion = 'kiddo/Insert/EditTeacherQuestion'
app.config.globalProperties.$PublishQuiz = 'kiddo/Insert/QuizPublish'
app.config.globalProperties.$UploadPhoto = 'kiddo/FileTransfer/UploadQuizQuestion'
app.config.globalProperties.$GetUsersPayment = 'kiddo/Read/GetUserDatas'
app.config.globalProperties.$GetCheckPassword = 'kiddo/Read/checkPaymentPassword'
app.config.globalProperties.$EwalletDirectPayment = 'kiddo/Insert/EwalletDirectPayment'
app.config.globalProperties.$EwalletAmount = 'kiddo/Read/WalletAmount'
app.config.globalProperties.$PaymentListByStudent = 'kiddo/read/PaymentLists'
app.config.globalProperties.$ScheduleStudent = 'kiddo/read/SchedulesStudents'
app.config.globalProperties.$ScheduleStudentWeb = 'kiddo/read/SchedulesStudentsWeb'
app.config.globalProperties.$ScheduleStudentWebAll = 'kiddo/read/SchedulesStudentsWebAll'
app.config.globalProperties.$ReportCardByUserId = 'kiddo/read/ReportCardByUserId'
app.config.globalProperties.$QuizScoreByParent = 'kiddo/read/QuizStudentHistoryDetailByUserId'

app.config.globalProperties.$StudentStartQuiz = 'kiddo/Insert/QuizStartStudent'
app.config.globalProperties.$QuizQuestion = 'kiddo/Read/QuizStudentCurrentQues'
app.config.globalProperties.$StudentSubmitAnswer = 'kiddo/Insert/StudentSubmitAnswer'
app.config.globalProperties.$ListQuestion = 'kiddo/Read/ListQuestionByQuizId'
app.config.globalProperties.$StudentList = 'kiddo/Read/GetStudentListByParentId'
app.config.globalProperties.$ListTeacherQuizBySubjectId = 'kiddo/Read/ListTeacherQuizBySubjectId'
app.config.globalProperties.$QuizStudentDetail = 'kiddo/Read/StudentQuizGroupBySubjectId'
app.config.globalProperties.$ListStudentQuizBySubjectId = 'kiddo/Read/StudentQuizList'
app.config.globalProperties.$GetStudentFinalScore = 'kiddo/Read/GetStudentFinalScore'
app.config.globalProperties.$QuizStudentRecordBySubjectId = 'kiddo/Read/QuizStudentRecordBySubjectId'
app.config.globalProperties.$QuizStudentHistoryByQuiz = 'kiddo/Read/QuizStudentHistoryByQuiz'
app.config.globalProperties.$QuizStudentLeaderBoard = 'kiddo/Read/QuizStudentLeaderBoard'
app.config.globalProperties.$QuizTeacherLeaderBoard = 'kiddo/Read/QuizTeacherLeaderBoards'
app.config.globalProperties.$QuizStudentHistoryDetailByQuiz = 'kiddo/Read/QuizStudentHistoryDetailByQuiz'
app.config.globalProperties.$StudentProfile = 'kiddo/Read/GetStudentProfile'
app.config.globalProperties.$ParentProfile = 'kiddo/Read/ParentProfile'
app.config.globalProperties.$QuizStudentStatisticAverageScore = 'kiddo/Read/QuizStudentStatisticAverageScore'
app.config.globalProperties.$QuizTeacherStatisticTopRankStudents = 'kiddo/Read/QuizTeacherStatisticTopRankStudents'
app.config.globalProperties.$QuizTeacherStatisticQuizCount = 'kiddo/Read/QuizTeacherStatisticQuizCount'
app.config.globalProperties.$QuizTeacherStatisticTopQuizRank = 'kiddo/Read/QuizTeacherStatisticTopQuizRank'

app.config.globalProperties.$GetQuestionDetail = 'kiddo/Read/GetQuestionDetail'
app.config.globalProperties.$LoginUserDetailWebs = 'kiddo/Read/LoginUserDetailWebs'
app.config.globalProperties.$LoginUserDetailAdmin = 'kiddo/Read/LoginUserDetailAdmin'
app.config.globalProperties.$StudentListAuthorize = 'kiddo/read/AllStudentListAuthorize'
app.config.globalProperties.$GetProfilePhotoAuthorize = 'kiddo/Read/GetProfilePhotoAuthorize'
app.config.globalProperties.$GetWalletListWeb = 'kiddo/Read/GetWalletListWeb'
app.config.globalProperties.$GenerateEWallet = 'kiddo/Read/GenerateEWallet'
app.config.globalProperties.$GetListCoupon = 'kiddo/read/GetListCoupon'
app.config.globalProperties.$GetListCouponPaginated = 'kiddo/read/GetListCouponPaginated'

//FindTutor
app.config.globalProperties.$GetFindTutorDetail = 'kiddo/Read/GetFindTutorDetail'
app.config.globalProperties.$SetSchedule = 'kiddo/insert/TeacherSetSchedule'
app.config.globalProperties.$DeleteTeacherSubjectGrade = 'kiddo/insert/DeleteTeacherSubjectGrade'

//Teacher Profile
app.config.globalProperties.$TeacherProfile = 'kiddo/Read/UserProfile'
app.config.globalProperties.$TeacherSubjectGrade = 'kiddo/Read/TeacherSubjectGrade'
app.config.globalProperties.$TeacherAcademiceProfile = 'kiddo/Read/TeacherAcademiceProfile'
app.config.globalProperties.$TeacherWorkBackground = 'kiddo/Read/TeacherWorkBackground'
app.config.globalProperties.$TeacherAreasOfExpertise = 'kiddo/Read/TeacherAreasOfExpertise'
app.config.globalProperties.$TeacherProfessional = 'kiddo/Read/TeacherProfessional'
app.config.globalProperties.$TeacherLanguage = 'kiddo/Read/TeacherLanguage'
app.config.globalProperties.$TeacherSalary = 'kiddo/read/GetTeacherSalary'
app.config.globalProperties.$ScheduleTeacherWeb = 'kiddo/read/TeacherTimeTableWeb'
app.config.globalProperties.$QuizTeacherLeaderboardAll = 'kiddo/read/QuizTeacherLeaderBoardsAll'
app.config.globalProperties.$ListEwallet = 'kiddo/read/getwalletlist'
app.config.globalProperties.$QuizTeacher = 'kiddo/read/QuizCount'
app.config.globalProperties.$CountQuizQuizStudent = 'kiddo/read/CountQuizStudent'
app.config.globalProperties.$StudentProfileById = 'kiddo/Read/GetStudentProfileByUserId'

//Create or Edit Teacher Profile
app.config.globalProperties.$InsertUpdateProfessionalProfile = 'kiddo/Insert/TeacherProfessionalProfileCreatedEdit'
app.config.globalProperties.$InsertUpdateAcademiceProfile = 'kiddo/Insert/TeacherAcademicProfileCreatedEdit'
app.config.globalProperties.$InsertUpdateAreaofExpertises = 'kiddo/Insert/TeacherAreasOfExpertiseCreatedEdit'
app.config.globalProperties.$InsertUpdateWorkBackground = 'kiddo/Insert/TeacherWorkBackgroundCreatedEdit'

app.config.globalProperties.$InsertNewSchedule = 'kiddo/Insert/CreateScheduleByTeacher'
app.config.globalProperties.$UpdateSchedules = 'kiddo/insert/EditScheduleByTeacher'
app.config.globalProperties.$StudentFilterSubject = 'kiddo/Insert/StudentFilterSubject'
app.config.globalProperties.$TeacherConfirmClass = 'kiddo/Insert/TeacherConfirmClass'
app.config.globalProperties.$StudentResponse = 'kiddo/Insert/StudentResponse'
app.config.globalProperties.$RegisterStudent = 'kiddo/insert/RegisterStudent'
app.config.globalProperties.$RegisterManualStudent = 'kiddo/insert/RegisterManualStudent'
app.config.globalProperties.$RegisterManualStudentTc = 'kiddo/insert/RegisterManualStudentTc'
app.config.globalProperties.$NewSubject = 'kiddo/insert/NewSubject'
app.config.globalProperties.$InsertWaitingList = 'kiddo/insert/WaitingList'
app.config.globalProperties.$TeacherTeachSubject = 'kiddo/insert/TeacherTeachSubject'
app.config.globalProperties.$TeacherAddNewSubject = 'kiddo/insert/TeacherAddNewSubject'
app.config.globalProperties.$RegisterNewSubjectGrade = 'kiddo/insert/RegisterNewSubjectGrade'
app.config.globalProperties.$InsertStudentSchedule = 'kiddo/insert/STUDENTSCHEDULE'
app.config.globalProperties.$InsertDirectFindTutorOneToOne = 'kiddo/insert/DirectFindTutorOneToOne'
app.config.globalProperties.$InsertDirectFindTutorGrouping = 'kiddo/insert/DirectFindTutorGrouping'
app.config.globalProperties.$InsertStudentPackage = 'kiddo/insert/StudentPackageWeb'
app.config.globalProperties.$SubmitVCZoomDetails = 'kiddo/insert/submitVCZoomDetails'

app.config.globalProperties.$InsertFaq = 'kiddo/insert/Faq'

app.config.globalProperties.$UpdateWaiting = 'kiddo/update/WaitingList'
app.config.globalProperties.$UpdateAcceptJob = 'kiddo/update/AcceptJob'

app.config.globalProperties.$UpdateProfessionalProfile = 'kiddo/update/ProfessionalProfile'
app.config.globalProperties.$UpdateAreaOfExpertise = 'kiddo/update/AreaOfExpertise'
app.config.globalProperties.$TeacherDeleteSubject = 'kiddo/update/UpdateTeacherSubject'

app.config.globalProperties.$ContactUs = 'contact/index'
app.config.globalProperties.$RegisterPartner = 'kiddo/insert/Partner'

app.config.globalProperties.$LoginTeacher = 'kiddo/insert/LoginTeachers'
app.config.globalProperties.$LoginStudent = 'kiddo/insert/LoginStudents'
app.config.globalProperties.$ForgotPassword = 'kiddo/insert/ForgotPassword'
app.config.globalProperties.$ValidateForgotPasswordCode = 'kiddo/insert/ValidateForgotPasswordCode'
app.config.globalProperties.$ChangePassword = 'kiddo/insert/ChangePassword'

app.config.globalProperties.$EWalletSummary = 'kiddo/read/EWalletSummary'
app.config.globalProperties.$EWalletSummaryUnPaid = 'kiddo/read/EWalletSummaryUnPaid'
app.config.globalProperties.$EWalletSummaryUnPaidPaginated = 'kiddo/read/EWalletSummaryUnPaidPaginated'
app.config.globalProperties.$GetStudentsNeverPaid = 'kiddo/read/GetStudentsNeverPaid'
app.config.globalProperties.$GetTeacherAttendedNoStudent = 'kiddo/Read/GetTeacherAttendedNoStudent'
app.config.globalProperties.$EWalletSummaryBySubject = 'kiddo/read/EWalletSummaryBySubject'
app.config.globalProperties.$InsertReloadWallet = 'kiddo/insert/ReloadWallet'

app.config.globalProperties.$LoginToken = 'kiddo/insert/LoginTokenTuitionCenter'
app.config.globalProperties.$CheckEwalletAmount = 'kiddo/insert/checkEwalletAmount'
app.config.globalProperties.$VideoConference = 'kiddo/Read/GetVideoLinkScheduleWeb'
app.config.globalProperties.$NotificationUnSeenCount = 'kiddo/Read/NotificationUnSeenCount'

app.config.globalProperties.$CheckJoinClass = 'kiddo/Read/CheckingJoinClass'

app.config.globalProperties.$InsertRegistrationTuitionCenter = 'kiddo/insert/submitRegistrationTuitionCenter'

//Dashboard
app.config.globalProperties.$AllParentList = 'kiddo/Read/AllParentListAuthorize'
app.config.globalProperties.$AllStudentList = 'kiddo/Read/AllStudentAuthorize'
app.config.globalProperties.$StudentDetailByIdAuthorize = 'kiddo/Read/StudentDetailByIdAuthorize'
app.config.globalProperties.$StudentsDetailByParent = 'kiddo/Read/StudentsDetailByParent'
app.config.globalProperties.$ViewPaymentStudentById = 'kiddo/read/GetPaymentStudentTc'

//READ API tc
app.config.globalProperties.$AllTransaction = 'kiddo/read/EWalletSummary'
app.config.globalProperties.$EWalletSummaryPaginated = 'kiddo/read/EWalletSummaryPaginated'
app.config.globalProperties.$EWalletParentNames = 'kiddo/read/EWalletParentList'
app.config.globalProperties.$RemainingTransaction = 'kiddo/read/EWalletSummaryByRemaining'
app.config.globalProperties.$EWalletSummaryByRemainingPaginated = 'kiddo/read/EWalletSummaryByRemainingPaginated'
app.config.globalProperties.$ViewSubject = 'kiddo/read/GetSubjectTc'
app.config.globalProperties.$ViewPackage = 'kiddo/read/GetPackageTc'
app.config.globalProperties.$ViewStudent = 'kiddo/read/GetStudentTc'
app.config.globalProperties.$ViewStudentLoad = 'kiddo/read/GetStudentTcLoad'
app.config.globalProperties.$ViewStudentHome = 'kiddo/read/GetStudentTcHome'
app.config.globalProperties.$ViewStudentCount = 'kiddo/read/GetStudentTcCount'
app.config.globalProperties.$ViewTeacher = 'kiddo/read/GetTeacherTc'
app.config.globalProperties.$ViewTeacherCount = 'kiddo/read/GetTeacherTcCount'
app.config.globalProperties.$ViewAttendanceStudent = 'kiddo/read/GetAttendanceStudentTc'
app.config.globalProperties.$ViewAttendanceTeacher = 'kiddo/read/GetAttendanceTeacherTc'
app.config.globalProperties.$ViewPaymentStudent = 'kiddo/read/GePaymentStudentTc'
app.config.globalProperties.$ViewPaymentTeacher = 'kiddo/read/GetPaymentTeacherTc'
app.config.globalProperties.$ViewSchedule = 'kiddo/read/GetScheduleTc'
app.config.globalProperties.$ViewScheduleByDate = 'kiddo/read/GetScheduleTcByDate'
app.config.globalProperties.$ViewNotification = 'kiddo/read/GetNotificationTc'
app.config.globalProperties.$ViewProfilePictureAdmin = 'kiddo/read/GetProfilePictureTcV2'
app.config.globalProperties.$UpdateProfilePictureAdmin = 'kiddo/update/UpdateProfilePictureAdminTc'
app.config.globalProperties.$ListGradeTc = 'kiddo/read/GetGradeListByTc'
app.config.globalProperties.$ListClassTc = 'kiddo/read/GetClassListByTc'
app.config.globalProperties.$GetScheduleBySubjectId = 'kiddo/read/GetScheduleTcBySubId'
app.config.globalProperties.$GetListWeklySchedule = 'kiddo/read/GetListWeklySchedule'
app.config.globalProperties.$GetWeeklyScheduleById = 'kiddo/read/GetWeeklyScheduleById'
app.config.globalProperties.$GetStudentReportCard = 'kiddo/read/GetStudentReportCard'
app.config.globalProperties.$GetGradeClasses = 'kiddo/read/GetGradeClass'
app.config.globalProperties.$GetListTeacherBySubId = 'kiddo/read/GetListTeacherForSubjectId'
app.config.globalProperties.$GetListReportCardBySubId = 'kiddo/read/GetListReportCardBySubId'
app.config.globalProperties.$GetSubjectById = 'kiddo/read/GetSubjectTcById'
app.config.globalProperties.$GetRateTeacherById = 'kiddo/read/GetSubjectTeacherRateTcById'
app.config.globalProperties.$GetPackageById = 'kiddo/read/GetPackageTcById'
app.config.globalProperties.$GetListSubjectTc = 'kiddo/read/GetListSubjectByTc'
app.config.globalProperties.$GetListSubjectPackageTc = 'kiddo/read/GetListSubjectByPackageId'
app.config.globalProperties.$GetListStudentPackage = 'kiddo/read/GetListStudentPackage'
app.config.globalProperties.$GetRateType = 'kiddo/read/GetRateType'
app.config.globalProperties.$GetTeacherById = 'kiddo/read/GetTeacherById'
app.config.globalProperties.$GetScheduleById = 'kiddo/read/GetAttendanceByScheduleId'
app.config.globalProperties.$GetAdditionPaymentStudent = 'kiddo/read/GetAdditionalPaymentStudentTc'
app.config.globalProperties.$GetReceiptStudentPayment = 'kiddo/read/GetReceiptStudentPayment'
app.config.globalProperties.$GetAdditionalPaymentTeacher = 'kiddo/read/GetAdditionalPaymentTeacher'
app.config.globalProperties.$GetDetailTeacher = 'kiddo/read/GetDetailTeachers'
app.config.globalProperties.$GetSlipTeacher = 'kiddo/read/GetSlipTeacher'
app.config.globalProperties.$GetMassNotification = 'kiddo/Read/GetMassNotification'
app.config.globalProperties.$GetRegistrationFee = 'kiddo/Read/GetRegistrationFeeTc'
app.config.globalProperties.$GetDetailRegistrationFee = 'kiddo/Read/GetDetailRegistrationFeeTc'
app.config.globalProperties.$GetListEpayTrackData = 'kiddo/Read/GetListEpayTrack'
app.config.globalProperties.$GetListEpayTrackDataByDateRange = 'kiddo/Read/GetListEpayTrackByDateRange'
app.config.globalProperties.$GetListEpayTrackByDateRangePaginated = 'kiddo/Read/GetListEpayTrackByDateRangePaginated'
app.config.globalProperties.$GetListNotificationMass = 'kiddo/Read/GetListNotificationMass'
app.config.globalProperties.$GetListPeopleNotificationMass = 'kiddo/Read/GetListPeopleNotificationMass'
app.config.globalProperties.$GetListAllPeople = 'kiddo/Read/GetListPeople'
app.config.globalProperties.$GetUsersNoStudent = 'kiddo/Read/GetUsersNoStudent'
app.config.globalProperties.$GetAdminRole = 'kiddo/Read/GetAdminRole'
app.config.globalProperties.$GetAdminStaffList = 'kiddo/Read/GetAdminStaffList'
app.config.globalProperties.$AddAdminStaff = 'kiddo/Insert/AddAdminStaff'
app.config.globalProperties.$UpdateAdminStaffRole = 'kiddo/Insert/UpdateAdminStaffRole'
app.config.globalProperties.$DeleteAdminStaff = 'kiddo/Insert/DeleteAdminStaff'
app.config.globalProperties.$ResetAdminStaffPassword = 'kiddo/Insert/ResetAdminStaffPassword'
app.config.globalProperties.$GetListBillingSubscription = 'kiddo/Read/ListBillingSubscription'
app.config.globalProperties.$GetCheckSubsLoginAdmin = 'kiddo/Read/CheckSubsLoginAdmin'
app.config.globalProperties.$GetListCountry = 'kiddo/Read/GetCountry'
app.config.globalProperties.$ViewScheduleByMonthYear = 'kiddo/Read/GetScheduleTcByMonth'

//INSERT API TC
app.config.globalProperties.$InsertNewSubjectTc = 'kiddo/insert/CreateSubject'
app.config.globalProperties.$InsertNewSubjectTcAdmin = 'kiddo/insert/CreateNewSubjectAdminDashboard'
app.config.globalProperties.$InsertNewGradeClassTc = 'kiddo/insert/CreateGradeClass'
app.config.globalProperties.$InsertNewScheduleBySubId = 'kiddo/insert/CreateWeeklySchedules'
app.config.globalProperties.$InsertNewReportCard = 'kiddo/insert/CreateReportCard'
app.config.globalProperties.$InsertAssignTeacher = 'kiddo/insert/CreateAssignTeacherToSubject'
app.config.globalProperties.$InsertSchedule = 'kiddo/insert/CreateSchedulesTc'
app.config.globalProperties.$InsertScheduleNew = 'kiddo/insert/CreateSchedulesTcNew'
app.config.globalProperties.$InsertPackage = 'kiddo/insert/CreatePackageTc'
app.config.globalProperties.$InsertAssignSubject = 'kiddo/insert/InsertAssignSubjectPackage'
app.config.globalProperties.$InsertAssignStudentPackage = 'kiddo/insert/InsertAssignStudentPackage'
app.config.globalProperties.$InsertRegisterAdmin = 'kiddo/insert/RegisterAdmin'
app.config.globalProperties.$InsertImportStudent = 'kiddo/insert/ImportStudentTc'
app.config.globalProperties.$InsertRegisterTeacher = 'kiddo/insert/RegisterTeacher'
app.config.globalProperties.$InsertAddPaymentStudent = 'kiddo/insert/CreateAdditionalPaymentStudent'
app.config.globalProperties.$InsertAddPaymentTeacher = 'kiddo/insert/CreateAdditionalPaymentTeacher'
app.config.globalProperties.$InsertSetPaymentStudent = 'kiddo/insert/CreateSetPaymentStudent'
app.config.globalProperties.$InsertSetPaymentTeacher = 'kiddo/insert/CreateSetPaymentTeacher'
app.config.globalProperties.$InsertBroadcast = 'kiddo/insert/SendBroadcast'
app.config.globalProperties.$InsertMassGroup = 'kiddo/insert/CreateMassGroup'
app.config.globalProperties.$InsertGenerateInvoice = 'kiddo/insert/GenerateInvoice'
app.config.globalProperties.$InsertPeople = 'kiddo/insert/InsertPeople'
app.config.globalProperties.$InsertNotificationMass = 'kiddo/insert/SendMassNotification'
app.config.globalProperties.$UpdateSubscribePackageFree = 'kiddo/update/UpdateRenewPackage'
app.config.globalProperties.$UpdateRenewPackagePay = 'kiddo/update/UpdateRenewPackagePayment'
app.config.globalProperties.$UpdatePaidSubscription = 'kiddo/update/UpdatePaidSubscription'

app.config.globalProperties.$DeleteWeeklySchedule = 'kiddo/delete/RemoveWeeklySchedule'
app.config.globalProperties.$DeleteGrade = 'kiddo/delete/RemoveGrade'
app.config.globalProperties.$DeleteSubject = 'kiddo/delete/RemoveSubject'
app.config.globalProperties.$DeleteTeacherOnSubject = 'kiddo/delete/RemoveTeacherSubject'
app.config.globalProperties.$DeleteReportCard = 'kiddo/delete/RemoveReportCards'
app.config.globalProperties.$DeleteAddPayment = 'kiddo/delete/DeleteAddPayment'
app.config.globalProperties.$DeleteTeacherRate = 'kiddo/delete/RemoveTeacherRate'
app.config.globalProperties.$DeleteTuitionPackage = 'kiddo/delete/RemoveTuitionPackage'
app.config.globalProperties.$DeleteSubjectTuitionPackage = 'kiddo/delete/RemoveSubjectTuitionPackage'
app.config.globalProperties.$DeleteStudentPackage = 'kiddo/delete/RemoveStudentPackage'
app.config.globalProperties.$DeleteAdditionalPaymentStudent = 'kiddo/delete/RemoveAdditionalPaymentStudent'
app.config.globalProperties.$DeletePaymentStudent = 'kiddo/delete/RemoveStudentPayment'
app.config.globalProperties.$DeleteSchedule = 'kiddo/delete/RemoveSchedule'
app.config.globalProperties.$DeleteUserMassNoti = 'kiddo/delete/RemoveUserMassNotification'
app.config.globalProperties.$DeleteGroupMass = 'kiddo/delete/RemoveGroupMassNotification'

app.config.globalProperties.$UpdateReportCard = 'kiddo/update/ReportCards'
app.config.globalProperties.$UpdateTuitionSubject = 'kiddo/update/TuitionSubject'
app.config.globalProperties.$UpdateTuitionPackage = 'kiddo/update/TuitionPackage'
app.config.globalProperties.$UpdateDiscount = 'kiddo/update/InsertDiscount'
app.config.globalProperties.$UpdateManualStudent = 'kiddo/update/EditRegistrationStudent'
app.config.globalProperties.$UpdateStatusStudent = 'kiddo/update/EditStatusStudent'
app.config.globalProperties.$UpdateTeacher = 'kiddo/update/EditTeacher'
app.config.globalProperties.$UpdateTeacherStatus = 'kiddo/update/EditTeacherStatus'
app.config.globalProperties.$UpdateStudentAttendance = 'kiddo/update/EditStudentAttendance'
app.config.globalProperties.$UpdateTeacherAttendance = 'kiddo/update/EditeacherAttendance'
app.config.globalProperties.$UpdateTeacherAttendanceBackup = 'kiddo/update/EditeacherAttendanceBackup'
app.config.globalProperties.$UpdateRefreshAttendance = 'kiddo/update/RefreshAttendance'
app.config.globalProperties.$UpdateRegistrationFee = 'kiddo/update/EditRegistrationFee'
app.config.globalProperties.$GetAttendanceEwallet = 'kiddo/read/CheckAttendanceEwallet'
app.config.globalProperties.$UpdateSubscribeProductSchedule = 'kiddo/update/UpdateSubscribeProductSchedule'

app.config.globalProperties.$FindTutorMsgAnalysis = 'kiddo/read/FindTutorMsgAnalysis'
app.config.globalProperties.$FindTutorMsgAnalysisPaginated = 'kiddo/read/FindTutorMsgAnalysisPaginated'
app.config.globalProperties.$FindTutorStillOpen = 'kiddo/read/FindTutorStillOpen'
app.config.globalProperties.$FindTutorStillOpenPaginated = 'kiddo/read/FindTutorStillOpenPaginated'
app.config.globalProperties.$FindTutorTeacherApply = 'kiddo/read/FindTutorTeacherApply'
app.config.globalProperties.$FindTutorTeacherApplyPaginated = 'kiddo/read/FindTutorTeacherApplyPaginated'
app.config.globalProperties.$GetSubjectTcWeb = 'kiddo/read/GetSubjectTcWeb'

app.config.globalProperties.$GetTuitionPaymentStudent = 'kiddo/read/TuitionPaymentStudent'
app.config.globalProperties.$GetCheckTcPackage = 'kiddo/read/GetCheckTcPackage'

app.config.globalProperties.$FindTutorListToRespondByLimitAuthorize = 'kiddo/Read/FindTutorListToRespondByLimitAuthorize'
app.config.globalProperties.$FindTutorListToRespondByLimitAuthorizeAll = 'kiddo/Read/FindTutorListToRespondByLimitAuthorizeAll'
app.config.globalProperties.$FindTutorListWaitingByLimitAuthorizeAll = 'kiddo/Read/FindTutorListWaitingByLimitAuthorizeAll'

app.config.globalProperties.$TotalPaidAndUnpaidByTc = 'kiddo/Read/TotalPaidAndUnpaidByTc'
app.config.globalProperties.$AskiddoListAll = 'kiddo/Read/AskiddoListAll'
app.config.globalProperties.$ScheduleByWeek = 'kiddo/Read/SchedulesStudentsByTc'
app.config.globalProperties.$AttendanceOverview = 'kiddo/Read/AttendanceOverview'
app.config.globalProperties.$AllNotificationLimitAuthorizeByWebTc = 'kiddo/Read/AllNotificationLimitAuthorizeByWebTc'

app.config.globalProperties.$GetAttendanceReport = 'kiddo/Read/GetAttendanceReport'
app.config.globalProperties.$GetAttendanceReportTeacher = 'kiddo/Read/GetAttendanceReportTeacher'
app.config.globalProperties.$GetDataPaginate = 'kiddo/Read/GetDataPaginate'
app.config.globalProperties.$GetDataPaginateFirst5 = 'kiddo/Read/GetDataPaginateFirst5'
app.config.globalProperties.$GetDataPaginateSubjectFirst5 = 'kiddo/Read/GetDataPaginateSubjectFirst5'
app.config.globalProperties.$GetCountSubjectPaginate = 'kiddo/Read/GetCountSubjectPaginate'
app.config.globalProperties.$GetSubjectTcLoop = 'kiddo/Read/GetSubjectTcLoop'
app.config.globalProperties.$ViewStudentTcLoop = 'kiddo/read/GetStudentTcLoop'

app.config.globalProperties.$AssignTeacher = 'kiddo/update/EditAssignTutor'

app.config.globalProperties.$CreateNewSubject = 'kiddo/insert/CreateNewSubject'
app.config.globalProperties.$CreateNewExam = 'kiddo/insert/CreateNewExam'
app.config.globalProperties.$FindTutorList = 'kiddo/read/FindTutorList'
app.config.globalProperties.$GetTeacherCountry = 'kiddo/read/GetTeacherCountry'

app.config.globalProperties.$ListTc = 'kiddo/read/GetListTc'
app.config.globalProperties.$ListTeacherActive = 'kiddo/read/GetListTcActive'
app.config.globalProperties.$GetTeacherCV = 'kiddo/read/GetTeacherCV'

app.config.globalProperties.$GetScheduleTcByCurrentYear = 'kiddo/read/GetScheduleTcByCurrentYear'
app.config.globalProperties.$EditDetailStudent = 'kiddo/update/EditDetailStudent'

app.config.globalProperties.$GetTotalTodayVisitor = 'kiddo/read/GetTotalTodayVisitor'
app.config.globalProperties.$GetLastWeekVisits = 'kiddo/read/GetLastWeekVisits'
app.config.globalProperties.$GetMonthlyChartData = 'kiddo/read/GetMonthlyChartData'
app.config.globalProperties.$GetThisWeekVisits = 'kiddo/read/GetThisWeekVisits'
app.config.globalProperties.$NewGetPaymentTeacherTc = 'kiddo/read/NewGetPaymentTeacherTc'

//product
app.config.globalProperties.$GetListProduct = 'kiddo/read/GetListProduct'
app.config.globalProperties.$GetStudentTcWithLoose = 'kiddo/read/GetStudentTcWithLoose'
app.config.globalProperties.$GetListGradePackage = 'kiddo/read/GetListGradeProduct'
app.config.globalProperties.$GetListSubGradePackage = 'kiddo/read/GetListSubGradeProduct'
app.config.globalProperties.$GetListProductGradeSubGrade = 'kiddo/read/GetListProductGradeSubGrade'
app.config.globalProperties.$GetScheduleTcFlyhighs = 'kiddo/read/GetScheduleTcFlyhigh'
app.config.globalProperties.$GetListModuleFile = 'kiddo/read/GetListModuleFiles'
app.config.globalProperties.$ListSubjectPerPackage = 'kiddo/read/GetListSubjectPerPackage'
app.config.globalProperties.$GetListPaymentProduct = 'kiddo/read/GetListTransactionPurchased'
app.config.globalProperties.$GetListAllTransaction = 'kiddo/read/GetListAllTransaction'
app.config.globalProperties.$GetDetailAffiliate = 'kiddo/read/GetDetailAffiliate'
app.config.globalProperties.$GetListAffiliate = 'kiddo/read/GetListAffiliate'
app.config.globalProperties.$GetListAffiliateByAgent = 'kiddo/read/GetListTransactionByAgent'
app.config.globalProperties.$GetTotalAmountPerWeekGroupDate = 'kiddo/read/GetTotalAmountPerWeekGroupDate'
app.config.globalProperties.$GetTotalAmountPerMonthGroupDate = 'kiddo/read/GetTotalAmountPerMonthGroupDate'
app.config.globalProperties.$GetTotalAmountPerYearGroupDate = 'kiddo/read/GetTotalAmountPerYearGroupDate'
app.config.globalProperties.$GetTotalAmountPerDateGroupHour = 'kiddo/read/GetTotalAmountPerDateGroupHour'
app.config.globalProperties.$GetTotalAmountCustomDate = 'kiddo/read/GetTotalCustomDate'
app.config.globalProperties.$GetTotalAmountPerProduct = 'kiddo/read/GetTotalAmountPerProduct'
app.config.globalProperties.$GetScheduleList = 'kiddo/read/GetScheduleList'
app.config.globalProperties.$GetListTransactionPurchasedAll = 'kiddo/read/GetListTransactionPurchasedAll'
app.config.globalProperties.$GetListProductById = 'kiddo/read/GetProductById'
app.config.globalProperties.$GetListMasterPackage = 'kiddo/read/GetListMasterPackage'
app.config.globalProperties.$GetAllListMasterPackage = 'kiddo/read/GetAllListMasterPackage'

app.config.globalProperties.$DeleteListGrade = 'kiddo/delete/RemoveListGrade'
app.config.globalProperties.$DeleteModule = 'kiddo/delete/DeleteModule'
app.config.globalProperties.$RemovePurchases = 'kiddo/delete/RemovePurchases'
app.config.globalProperties.$UpdateMasterPackageStatus = 'kiddo/update/UpdateMasterPackageStatus'

app.config.globalProperties.$UpdateStatusProduct = 'kiddo/update/UpdateStatusProduct'

app.config.globalProperties.$UploadNewProduct = 'aws/UploadNewProduct'
app.config.globalProperties.$StoreMasterPackage = 'aws/StorePackage'
app.config.globalProperties.$StoreProduct = 'aws/StoreProduct'

app.config.globalProperties.$UploadModuleFile = 'aws/UploadModuleFile'
app.config.globalProperties.$AssignModuleFiles = 'aws/AssignModuleFiles'

app.config.globalProperties.$PurchaseProduct_AutoRegister = 'kiddo/insert/PurchaseProduct_AutoRegister'
app.config.globalProperties.$InsertAssignStudentPackages = 'kiddo/insert/InsertAssignStudentPackages'
app.config.globalProperties.$InsertCoupon = 'kiddo/update/SetCoupon'
app.config.globalProperties.$InsertMasterPackage = 'kiddo/insert/InsertMasterPackage'

app.use(CoreuiVue, { icons })
app.use(router)
app.use(store)

// Warm up all slow dashboard endpoints immediately on app load so the
// server is awake before the user navigates to any page.
;[
  'kiddo/Insert/IsAuthenticated',
  'kiddo/Read/LoginUserDetailAdmin',
  'kiddo/read/GetStudentTcCount',
  'kiddo/read/GetTeacherTcCount',
  'kiddo/Read/TotalPaidAndUnpaidByTc',
  'kiddo/read/GetScheduleList',
  'kiddo/read/GetListTransactionPurchased',
].forEach(url => baseAPI.get(url, { withCredentials: true }).catch(() => {}))

app.mount('#app')
